import { ErrorMessage, Field, Form, Formik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import * as Yup from 'yup'
import Avatar from '@mui/material/Avatar'
import { useNavigate, useParams } from 'react-router-dom'
import Button from '../../../components/button/Button'
import './facultyForm.scss'
import NewInput from '../../../components/input/NewInput'
import { ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import Calendar from '../../../components/calendar/Calendar'
import {
  convertDateFormatCalendar,
  convertTZToDate,
  generateDropdownOptions,
  handleEmail,
  handleInput,
  handleInputAddress,
  handleInputStringWithNum,
  handleName,
  handlePassword,
} from '../../../utility/genricFunction'
import {
  createFaculty,
  editFaculty,
  getBank,
  getBillingInfo,
} from '../../../store/builders/addFaculty/add-faculty.builder'
import { useDispatch, useSelector } from 'react-redux'
import {
  FACULTY_BANK_BARNCH_MAX_LENGTH,
  FACULTY_NAME_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  VALIDATION_MESSAGES,
} from '../../../utility/constantValidationMessages'
import { getAreaByCityId, getCityByStateId } from '../../../store/builders/masterDataSet/masterDataSet.builder'
import { toast } from 'react-toastify'
import { getFacultyDetails } from '../../../store/builders/faculty/faculty.builder'
import Loader from '../../../components/loader/Loader'

function FacultyForm() {
  const { id } = useParams()
  const fileRef = useRef()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { facultyDetailsData, loading } = useSelector((state)=>state.faculty)
  const [profilePhotoPreview, setProfilePhotoPreview] = useState(null)
  const { billingRecords } = useSelector((state) => state?.addFaculty?.allBillingInfo)
  const {areas, cites, states } = useSelector(store => store.masterDataSet)

    const [initialValues, setInitialValues] = useState({
    facultyPhoto: null,
    facultyName: '',
    userPhone: '',
    userPassword: '',
    userEmail: '',
    addressLine: '',
    stateId: '',
    cityId: '',
    areaId: '',
    aboutFaculty: '',
    hourlyRate: '',
    rateEffectiveDate: '',
    bankName: '',
    bankAccountNo: '',
    bankIfscCode: '',
    bankBranchName: '',
  })

  useEffect(() => {
    dispatch(getBank())
    
    if(id){

      dispatch(getFacultyDetails(id))
      dispatch(getBillingInfo(id))
    }

    
    return () => dispatch({ type: 'faculty/clearFacultyDetailsdata' })
  }, [])



  const cityOption = useRef([])
  const areaOption = useRef([])

  useEffect(() => {
    async function fetchFacultyDetails() {
      if (id) {

        if (facultyDetailsData.userPhoto) {
          setProfilePhotoPreview(facultyDetailsData.userPhoto)
        }

        const filteredCity = cites.filter((item) => item.state_id === facultyDetailsData?.stateId)
        cityOption.current = generateDropdownOptions(filteredCity, 'city_name', 'city_id')

        const filteredArea = areas.filter((item)=>item.city_id === facultyDetailsData?.cityId)
        areaOption.current = generateDropdownOptions(filteredArea, 'area_name', 'area_id')

        setInitialValues({
          facultyName: facultyDetailsData?.userName,
          userPhone: facultyDetailsData?.userPhone,
          userEmail: facultyDetailsData?.userEmail,
          addressLine: facultyDetailsData?.userAddress1,
          stateId: facultyDetailsData?.stateId,
          cityId: facultyDetailsData?.cityId,
          areaId: facultyDetailsData?.areaId,
          aboutFaculty: facultyDetailsData?.facultyAbout,
          hourlyRate: facultyDetailsData?.hourlyRate,
          rateEffectiveDate: facultyDetailsData?.rateEffectiveDate,
          bankName: facultyDetailsData?.bankName,
          bankAccountNo: facultyDetailsData?.accountNo,
          bankIfscCode: facultyDetailsData?.ifscCode,
          bankBranchName: facultyDetailsData?.branchName,
        })
      }
    }

    fetchFacultyDetails()

  }, [id,facultyDetailsData])

  const validationSchema = Yup.object().shape({
    // facultyPhoto: Yup.mixed().required('Faculty Photo is required'), // Assuming file upload validation
    facultyName: Yup.string()
      .required(VALIDATION_MESSAGES.FACULTY_FORM.FACULTY_NAME_REQUIRED)
      .max(FACULTY_NAME_MAX_LENGTH, VALIDATION_MESSAGES.FACULTY_FORM.FACULTY_NAME_MAX),
    userPhone: Yup.string()
      .required(VALIDATION_MESSAGES.FACULTY_FORM.FACULTY_PHONE_NUMBER_REQUIRED)
      .matches(/^[0-9]{10}$/, VALIDATION_MESSAGES.FACULTY_FORM.FACULTY_PHONE_NUMBER_VALID),
    userEmail: Yup.string()
      .matches(/\S+@\S+\.\S+/, VALIDATION_MESSAGES.EMAIL_VALID)
      .required(VALIDATION_MESSAGES.EMAIL_REQUIRED),
    userPassword: id
      ? Yup.string().optional()
      : Yup.string()
          .required(VALIDATION_MESSAGES.PASSWORD_REQUIRED)
          .min(PASSWORD_MIN_LENGTH, VALIDATION_MESSAGES.PASSWORD_VALID)
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            VALIDATION_MESSAGES.PASSWORD_VALID,
          ),
    // aboutFaculty: Yup.string()
    //   .required(`About Faculty is required`)
    //   .max(500, `About Faculty must be less than 500 characters`),
    hourlyRate: Yup.number().required(VALIDATION_MESSAGES.FACULTY_FORM.FACULTY_HOURLY_RATE_REQUIRED).positive(),
    rateEffectiveDate: Yup.date().required(VALIDATION_MESSAGES.APPLICABLE_DATE),
    bankName: Yup.string().required(VALIDATION_MESSAGES.BANK_NAME_REQUIRED),
    bankAccountNo: Yup.string()
      .required(VALIDATION_MESSAGES.BANK_ACCOUNT_NUMBER_REQUIRED)
      .matches(/^[0-9]{9,18}$/, VALIDATION_MESSAGES.BANK_ACCOUNT_NUMBER_VALID),
    bankIfscCode: Yup.string()
      .required(VALIDATION_MESSAGES.BANK_IFSC_CODE_REQUIRED)
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, VALIDATION_MESSAGES.BANK_IFSC_CODE_VALID),
    bankBranchName: Yup.string()
      .required(VALIDATION_MESSAGES.BANK_BRANCH_REQUIRED)
      .max(FACULTY_BANK_BARNCH_MAX_LENGTH, VALIDATION_MESSAGES.FACULTY_FORM.FACULTY_BANK_BARNCH_MAX),
  })

  const handleStateDropdownChange = (e, setFieldValue) => {
    e.preventDefault()
    const stateValue = e.target.value
    setFieldValue('stateId', stateValue)
    setFieldValue('areaId', '')
    setFieldValue('cityId', '')

    const cities = cites.filter((item) => item.state_id === stateValue)

    const cityOptions = cities.map((city) => ({
      label: city.city_name,
      value: city.city_id,
    }))

    cityOption.current = cityOptions?.length ? cityOptions : []
  }

  function handleFormSubmit(payload) {
    const formData = new FormData()
    payload.facultyAbout && formData.append('aboutFaculty', payload.facultyAbout)
    formData.append('addressLine', payload.addressLine)
    formData.append('areaId', payload.areaId)
    formData.append('bankAccountNo', payload.bankAccountNo)
    formData.append('bankBranchName', payload.bankBranchName)
    formData.append('bankIfscCode', payload.bankIfscCode)
    formData.append('bankName', payload.bankName)
    formData.append('cityId', payload.cityId)
    formData.append('facultyName', payload.facultyName)
    formData.append('hourlyRate', payload.hourlyRate)
    formData.append('rateEffectiveDate', payload.rateEffectiveDate)
    formData.append('stateId', payload.stateId)
    formData.append('userEmail', payload.userEmail)
    payload?.userPassword && formData.append('userPassword', payload.userPassword)
    formData.append('userPhone', payload.userPhone)

    if (id) {
      if (payload.facultyPhoto) {
        formData.append('file', payload.facultyPhoto)
      }
      dispatch(editFaculty({ id, formData, navigate }))
    } else {
      if (payload.facultyPhoto) {
        formData.append('file', payload.facultyPhoto)
      }
      dispatch(createFaculty({ formData, navigate }))
    }
  }

  function handlePhotoSelect() {
    if (fileRef.current) {
      fileRef.current.click()
    }
  }

  const breadCrumbsArr = [
    {
      title: id ? UI_CONSTANT.FACULTY.EDIT_FACULTY : UI_CONSTANT.FACULTY.LABEL_FACULTY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.FACULTY.LABEL_FACULTY,
      link: ROUTES_PATH.FACULTY,
    },
    {
      title: id ? UI_CONSTANT.FACULTY.EDIT_FACULTY : UI_CONSTANT.FACULTY.NEW_FACULTY,
      link: id ? ROUTES_PATH.FACULTY_EDIT.replace(':id', id) : ROUTES_PATH.FACULTY_ADD,
    },
  ]

  const handleProfilePhotoChange = (event, setFieldValue) => {
    const file = event.target.files[0]

    if (file) {
      // Check file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(file.type)) {
        toast.error('Please select a valid image file (PNG, JPG, JPEG)', {
          className: 'custom-toast-error',
          progressStyle: { background: '#C53C43' },
        })
        return
      }

      // setProfilePhoto(file);
      setFieldValue('facultyPhoto', file)
      setProfilePhotoPreview(URL.createObjectURL(file))
    }
  }

  const handleCityDropdownChange = (e, setFieldValue) => {
    e.preventDefault()
    const cityValue = e.target.value
    setFieldValue('cityId', cityValue)
    setFieldValue('areaId', '')

    const area = areas.filter((item) => item.city_id === cityValue)

    const areaOptions = area.map((area) => ({
      label: area.area_name,
      value: area.area_id,
    }))


    areaOption.current = areaOptions?.length ? areaOptions : []
  }

  const handleAreaOnchange = (e, setFieldValue) => {
    e.preventDefault()
    const areaId = e.target.value
    setFieldValue('areaId', areaId)
  }

  return (
    <>
    {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && <div className='facultyForm-wrapper'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            const payload = { ...values }
            handleFormSubmit(payload)
          }}
          enableReinitialize
        >
          {({ values, handleChange, handleSubmit, setFieldValue }) => (
            <Form>
              <div className='facultyForm-header'>
                <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

                <div className='faculty-header-right'>
                  <Button disabled={loading} customClassName={'save-btn'} onClick={handleSubmit}>
                    {UI_CONSTANT.SAVE}
                  </Button>
                </div>
              </div>

              <div className='facultyForm'>
                <div className='facultyForm-inner-header'>
                  <h1>{UI_CONSTANT.FACULTY.FACULTY_INFORMATION}</h1>
                  <p>{UI_CONSTANT.FACULTY.FORM_DESCRIPTION}</p>
                </div>

                <div className='separatorLine'></div>

                <div className='facultyForm-input-fields'>
                  <div className='facultyForm-input-selectPhoto'>
                    <Avatar sx={{ height: '74px', width: '74px' }} src={profilePhotoPreview || values.facultyPhoto} />

                    <div className='facultyPhoto-select-btn-div'>
                      <input
                        type='file'
                        id='selectedFile'
                        ref={fileRef}
                        style={{ display: 'none' }}
                        name='facultyPhoto'
                        // onChange={(e) => {
                        //   setFieldValue('facultyPhoto', e.currentTarget.files[0])
                        // }}
                        accept='.png,.jpg,.jpeg'
                        onChange={(event) => handleProfilePhotoChange(event, setFieldValue)}
                      />

                      <input
                        type='button'
                        value='Upload Photo'
                        onClick={handlePhotoSelect}
                        className='photoSelect-btn'
                      />
                      <p>JPG, PNG, JPEG, format allowed</p>
                      <ErrorMessage name='facultyPhoto' component='div' className='error-msg' />
                    </div>
                  </div>

                  <NewInput
                    label={'Faculty name'}
                    name={'facultyName'}
                    placeholder={'Enter faculty name'}
                    // width={'32%'}
                    width={'100%'}
                    required={true}
                    onInput={handleName}
                  />
                  <NewInput
                    label={'Mobile No'}
                    name={'userPhone'}
                    placeholder={'Enter faculty mobile no'}
                    width={'100%'}
                    type={'text'}
                    required={true}
                    onInput={handleInput}
                    maxLength={10}
                    // autoCompleate={"off"}
                  />
                  <NewInput
                    label={'Email'}
                    name={'userEmail'}
                    placeholder={'Enter faculty email'}
                    // width={'32%'}
                    width={'100%'}
                    required={true}
                    onInput={handleEmail}
                    maxLength={50}
                  />

                  {!id && (
                    <NewInput
                      label={'Password'}
                      name={'userPassword'}
                      placeholder={'Enter password'}
                      // width={'32%'}
                      width={'100%'}
                      type={'password'}
                      required={true}
                      onInput={handlePassword}
                      minLength={'8'}
                      autoComplete='new-password'
                    />
                  )}

                  <div className='address-div'>
                    <NewInput
                      label={'Faculty Address'}
                      name={'addressLine'}
                      placeholder={'Enter faculty full address'}
                      // width={'98.8%'}
                      width={'100%'}
                      maxLength={100}
                      onInput={handleInputAddress}
                    />
                  </div>

                  <div className='facultyForm-input'>
                    <label htmlFor=''>
                      Faculty state
                    </label>
                    <PageDropdown
                      options={generateDropdownOptions(states, 'state_name', 'state_id')}
                      selectedValue={values.stateId}
                      className={'facultyForm-dropdown'}
                      onChange={(e) => handleStateDropdownChange(e, setFieldValue)}
                      name={'stateId'}
                      placeholder={'Select state'}
                    />
                    <ErrorMessage name='stateId' component='div' className='error-msg' />
                  </div>

                  <div className='facultyForm-input'>
                    <label htmlFor=''>
                      Faculty city
                    </label>
                    <PageDropdown
                      //  options={generateDropdownOptions(cites, 'city_name', 'city_id')}
                      options={cityOption.current}
                      selectedValue={values.cityId}
                      className={'facultyForm-dropdown'}
                      onChange={(e) => handleCityDropdownChange(e, setFieldValue)}
                      name={'cityId'}
                      placeholder={'Select city'}
                      disabled={!values.stateId}
                    />
                    <ErrorMessage name='cityId' component='div' className='error-msg' />
                  </div>

                  <div className='facultyForm-input'>
                    <label htmlFor=''>
                      Faculty area
                    </label>
                    <PageDropdown
                      options={areaOption.current}
                      selectedValue={values.areaId}
                      className={'facultyForm-dropdown'}
                      onChange={(e) => handleAreaOnchange(e, setFieldValue)}
                      name={'areaId'}
                      placeholder={'Select area'}
                      disabled={!values.cityId}
                    />
                    <ErrorMessage name='areaId' component='div' className='error-msg' />
                  </div>

                  <div className='facultyForm-input-textarea'>
                    <label htmlFor=''>About Faculty</label>
                    <textarea
                      placeholder='Enter here...'
                      rows={5}
                      cols={5}
                      // value={id ? initialValues.aboutFaculty : ""}
                      value={values.aboutFaculty}
                      name='aboutFaculty'
                      onChange={handleChange}
                      onInput={handleInputStringWithNum}
                    />
                    <ErrorMessage name='aboutFaculty' component='div' className='error-msg' />
                  </div>
                </div>
              </div>

              <div className='facultyForm'>
                <div className='facultyForm-inner-header'>
                  <h1>{UI_CONSTANT.FACULTY.FACULTY_BILLING_INFORMATION}</h1>
                  <p>{UI_CONSTANT.FACULTY.FORM_DESCRIPTION}</p>
                </div>

                <div className='separatorLine'></div>

                <div className='facultyForm-input-fields m-17'>
                  <div className='facultyForm-input'>
                    <label htmlFor=''>
                      Hourly Rate <span className='req-rate'>*</span>
                    </label>
                    <div className='hourly-input-wrapper'>
                      <Field
                        type='text'
                        placeholder='Hourly rate'
                        name='hourlyRate'
                        onInput={handleInput}
                        maxLength={5}
                      />
                      <p className='hourRate-placeholder'>/Hr</p>
                    </div>
                    <ErrorMessage name='hourlyRate' component='div' className='error-msg' />
                  </div>

                  <Calendar
                    label='Applicable Date'
                    name='rateEffectiveDate'
                    // width='32%'
                    width={'100%'}
                    required={true}
                    value={values.rateEffectiveDate}
                    onChange={(values) => setFieldValue('rateEffectiveDate', convertDateFormatCalendar(values))}
                  />
                </div>

                {id && (
                  <div className='faculty-billing-history-wrapper'>
                    <div className='separatorLine'></div>

                    {billingRecords?.length > 0 ? <>
                          <label htmlFor='' className='billing-history-label'>
                            Billing History
                          </label>
                          <div className='price-date'>
                            <div className='price-wrapper'>
                              <label htmlFor=''>PRICE</label>
                              <div className='price-div'>
                                {billingRecords &&
                                  billingRecords?.map((history, index) => <p key={index}>₹{history.amount}</p>)}
                              </div>
                            </div>

                            <div className='date-wrapper'>
                              <label htmlFor=''>DATE</label>
                              <div className='date-div'>
                                {billingRecords &&   
                                  billingRecords?.map((history, index) => (
                                    <p key={index}>₹{convertTZToDate(history.billingDate)}</p>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </> : <p>No billing History</p>}

                  </div>
                )}
              </div>

              <div className='facultyForm'>
                <div className='facultyForm-inner-header'>
                  <h1>{UI_CONSTANT.FACULTY.FACULTY_BANK_INFORMATION}</h1>
                  <p>{UI_CONSTANT.FACULTY.FORM_DESCRIPTION}</p>
                </div>

                <div className='separatorLine'></div>

                <div className='facultyForm-input-fields'>
                  <div className='facultyForm-input'>
                    <label htmlFor=''>
                      Bank<span className='required-symbol'>*</span>
                    </label>
                    <NewInput
                      // options={generateDropdownOptions(allBankData, 'bankName', 'bankId')}
                      selectedValue={values.bankName}
                      className={'facultyForm-dropdown'}
                      onChange={handleChange}
                      name={'bankName'}
                      width={'100%'}
                      placeholder={'Enter Bank Name'}
                    />
                  </div>

                  <NewInput
                    label={'Account No'}
                    name={'bankAccountNo'}
                    placeholder={'Enter your account number'}
                    type={'text'}
                    // width={'32%'}
                    width={'100%'}
                    required={true}
                    onInput={handleInput}
                    maxLength={17}
                  />
                  <NewInput
                    label={'IFSC Code'}
                    name={'bankIfscCode'}
                    placeholder={'Enter IFSC code'}
                    // width={'32%'}
                    width={'100%'}
                    required={true}
                    onChange={(e) => {
                      e.target.value = e.target.value.toUpperCase()
                      // Assuming you have a handleChange function to manage form state
                      handleChange(e)
                    }}
                  />

                  <div className='facultyForm-input'>
                    <label htmlFor=''>
                      Bank Branch<span className='required-symbol'>*</span>
                    </label>
                    <NewInput
                      // options={}
                      selectedValue={values.bankBranch}
                      className={'facultyForm-dropdown'}
                      onChange={handleChange}
                      name={'bankBranchName'}
                      placeholder={'Enter your Branch'}
                      width={'100%'}
                      onInput={handleInputStringWithNum}
                    />
                    <ErrorMessage name='bankBranch' component='div' className='error-msg' />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>}
    </>
  )
}

export default FacultyForm
